// extracted by mini-css-extract-plugin
export default {"Bluecheese":"#615CFF","White":"#FFFFFF","link":"G712663"};